import { render, staticRenderFns } from "./SnackbarContainer.vue?vue&type=template&id=25682ed8&"
import script from "./SnackbarContainer.vue?vue&type=script&lang=js&"
export * from "./SnackbarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25682ed8')) {
      api.createRecord('25682ed8', component.options)
    } else {
      api.reload('25682ed8', component.options)
    }
    module.hot.accept("./SnackbarContainer.vue?vue&type=template&id=25682ed8&", function () {
      api.rerender('25682ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/SnackbarContainer.vue"
export default component.exports